import { render } from "./OverlayNews.vue?vue&type=template&id=304f4b52&scoped=true"
import script from "./OverlayNews.vue?vue&type=script&lang=js"
export * from "./OverlayNews.vue?vue&type=script&lang=js"

import "./OverlayNews.vue?vue&type=style&index=0&id=304f4b52&lang=scss&scoped=true"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-304f4b52"]])

export default __exports__